import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Pack Publicación que Vende',
  desc: '30 publicaciones listas para copiar y pegar en Marketplace. 15 títulos gancho probados. Respuestas automáticas para WhatsApp.',
  value: '8.990',
  color: 'bg-brand-steel'
}, {
  num: '02',
  title: 'Kit Fotos Pro con Celular',
  desc: 'Setup barato con recursos de tu casa. 20 encuadres que detienen el scroll. Edición en 60 segundos con apps gratuitas.',
  value: '7.990',
  color: 'bg-brand-rust'
}, {
  num: '03',
  title: 'Checklist Taller Seguro y Prolijo',
  desc: 'Checklists imprimibles para cada etapa del trabajo. Las 12 fallas más comunes y cómo evitarlas. Planner semanal para el que tiene trabajo y poco tiempo.',
  value: '5.990',
  color: 'bg-brand-amber'
}, {
  num: 'GYM',
  title: 'Planos de Estructuras Metálicas para Gimnasios',
  desc: 'Estructuras metálicas y mobiliario de alto rendimiento para gimnasios. Ampliá tu mercado a un nicho con tickets mucho más altos.',
  value: '12.990',
  color: 'bg-green-700'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-brand-dark text-white" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="text-4xl md:text-6xl font-black text-brand-amber mb-6 uppercase tracking-tight" data-id="element-23">
            🎁 Más los Bonos de Regalo
          </h2>
          <p className="text-2xl font-bold text-gray-300 mb-4" data-id="element-24">
            Incluidos en tu compra — sin costo extra
          </p>
          <div className="inline-block bg-brand-green text-white text-2xl font-black px-8 py-3 rounded-full animate-pulse-fast shadow-[0_0_20px_rgba(22,163,74,0.5)]" data-id="element-25">
            🎁 GRATIS con tu compra hoy
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-26">
          {bonuses.map((b, i) => <div key={i} className="bg-[#292524] rounded-2xl overflow-hidden border border-gray-700 shadow-2xl flex flex-col h-full" data-id="element-27">
              <div className={`${b.color} p-4 py-6 flex flex-col items-center justify-center text-center relative`} data-id="element-28">
                <div className="absolute top-2 left-2 bg-white text-black font-black text-sm px-2 py-1 rounded-lg" data-id="element-29">
                  {b.num}
                </div>
                <h3 className="text-xl md:text-2xl font-black text-white leading-tight drop-shadow-md" data-id="element-30">
                  {b.num === 'GYM' ? '🏋️ BONO' : `BONO ${parseInt(b.num)}`}
                </h3>
                <p className="text-sm font-bold mt-2 text-white/90 drop-shadow-md px-2" data-id="element-31">
                  {b.title}
                </p>
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-32">
                <div className="flex items-center gap-2 mb-3" data-id="element-33">
                  <span className="text-xl" data-id="element-34">
                    {b.num === 'GYM' ? '🏋️' : '🎁'}
                  </span>
                  <h4 className="text-lg font-bold text-brand-amber" data-id="element-35">
                    {b.num === 'GYM' ? 'BONO GYM' : `BONO ${parseInt(b.num)}`}
                  </h4>
                </div>
                <h5 className="text-xl font-bold mb-3" data-id="element-36">{b.title}</h5>
                <p className="text-gray-300 text-base mb-6 flex-grow" data-id="element-37">
                  {b.desc}
                </p>

                <div className="mt-auto pt-4 border-t border-gray-700 flex justify-between items-center" data-id="element-38">
                  <div className="text-gray-400 font-medium text-sm" data-id="element-39">
                    Valor: <span className="line-through" data-id="element-40">${b.value}</span>
                  </div>
                  <div className="text-brand-green font-black text-xl" data-id="element-41">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Value Summary Table */}
        <div className="bg-[#292524] border-2 border-brand-amber rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-42">
          <div className="space-y-3 mb-6" data-id="element-43">
            <div className="flex justify-between text-lg text-gray-300" data-id="element-44">
              <span data-id="element-45">5 Tomos Maestros</span>
              <span data-id="element-46">$49.900</span>
            </div>
            <div className="flex justify-between text-lg text-gray-300" data-id="element-47">
              <span data-id="element-48">Bono 1 — Pack Publicación</span>
              <span data-id="element-49">$8.990</span>
            </div>
            <div className="flex justify-between text-lg text-gray-300" data-id="element-50">
              <span data-id="element-51">Bono 2 — Kit Fotos Pro</span>
              <span data-id="element-52">$7.990</span>
            </div>
            <div className="flex justify-between text-lg text-gray-300" data-id="element-53">
              <span data-id="element-54">Bono 3 — Checklist Taller</span>
              <span data-id="element-55">$5.990</span>
            </div>
            <div className="flex justify-between text-lg text-gray-300" data-id="element-56">
              <span data-id="element-57">Bono Gym — Planos Gym</span>
              <span data-id="element-58">$12.990</span>
            </div>
            <div className="border-t border-gray-600 pt-3 flex justify-between text-xl font-bold text-white" data-id="element-59">
              <span data-id="element-60">VALOR TOTAL</span>
              <span className="line-through text-gray-400" data-id="element-61">$85.860</span>
            </div>
          </div>
          <p className="text-3xl md:text-4xl font-black text-brand-green text-center" data-id="element-62">
            HOY PAGÁS SOLO $19.990
          </p>
        </div>
      </div>
    </section>;
}